<template>
  <BgImageLayout :title="`Manual title list for product: ${product.name}`">
    <q-card class="bg-white">
      <q-card-section>
        <form @submit.prevent="process()">
          <div class="row q-col-gutter-md">
            <div class="col-xs-3">
              <q-input id="name" v-model="formData.name" name="name" label="Name" type="text" outlined />
            </div>
            <div class="col col-md-3">
              <LmDatePicker
                v-model="$v.formData.valid_from.$model"
                :error="$v.formData.valid_from.$error"
                :error-message="$v_displayMessage($v.formData.valid_from)"
                label="Valid from *"
              />
            </div>
            <div class="col col-md-3">
              <LmDatePicker
                v-model="formData.valid_to"
                :options="date => date >= formData.valid_from"
                label="Valid to"
              />
            </div>
            <div class="col-xs-12">
              <p>
                You must specify the period that the title-list covers. So, if you know that the title list will be the
                same for a 3-year agreement term, you can simply set the expiration date of the title-list accordingly.
              </p>
            </div>
          </div>
          <div class="row q-col-gutter-md">
            <div class="col-xs-12">
              <lm-publications-list
                :row-data="formData.publications"
                :columns="productTitleListData"
                :update-publication-remotely="false"
                :entity="formData"
                store-namespace="titleLists"
                @insert-publication="insertPublication($event)"
                @update-publication="updatePublication($event)"
                @delete-publication="deletePublication($event)"
                @save="saveTitleList()"
              />
            </div>
          </div>
        </form>
      </q-card-section>
    </q-card>
  </BgImageLayout>
</template>

<script>
import validations from './title-lists-manual-validations'
import { LmFormObject } from '@/lib/models/lm-form-object.class'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'
// Components
import LmPublicationsList from './PublicationsList'
import LmDatePicker from '@/reusable/LmDatePicker/LmDatePicker'

export default {
  name: 'LmPageTitleListsManual',
  components: {
    LmPublicationsList,
    LmDatePicker
  },
  mixins: [validations],
  data: function() {
    return {
      formData: new LmFormObject({
        name: null,
        valid_from: null,
        valid_to: null,
        publications: []
      })
    }
  },
  computed: {
    ...mapState({
      productTitleListData: state => state.titleLists.productTitleListManualData,
      product: state => state.products.single
    })
  },
  watch: {
    'formData.valid_from'(val) {
      this.formData.valid_to = moment(val, this.settings.date_format)
        .add(1, 'year')
        .subtract(1, 'day')
        .format(this.settings.date_format)
    }
  },
  created() {
    this.formData.name = this.product.name + ' title list'
  },
  methods: {
    saveTitleList() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      let data = cloneDeep(this.formData)
      delete data.errors
      delete data.originalData
      data.valid_from = this.formatDateForPost(data.valid_from, this.settings.date_format)
      data.valid_to = this.formatDateForPost(data.valid_to, this.settings.date_format)
      data.publications.forEach(publication => {
        delete publication.id
      })
      this.$store.dispatch('titleLists/saveManual', {
        value: data,
        product: this.product,
        next: { name: 'title-list' }
      })
    },
    insertPublication(publication) {
      let publications = cloneDeep(this.formData.publications)
      publications.splice(0, 0, publication)
      this.$set(this.formData, 'publications', publications)
    },
    updatePublication(payload) {
      let publications = cloneDeep(this.formData.publications)
      publications[payload.index] = payload.publication
      this.$set(this.formData, 'publications', publications)
    },
    deletePublication(params) {
      let data = cloneDeep(this.formData.publications)
      data.splice(params.rowIndex, 1)
      this.$set(this.formData, 'publications', data)
    }
  }
}
</script>
